import React from 'react'
import { Navbar } from "../components";
import { Link } from "react-router-dom";
import Header from './../components/header';
import Footer from './../components/Footer';


const Thankyou = () => {
    return (
        <>
          <Header></Header>

            <div className="thankyou-page container py-5 text-center">
                <div className="row justify-content-center m-auto">
                    <div className="col-md-8">
                        {/* Success Icon */}
                        <div className="mb-4">
                            <i className="fa fa-check-circle text-success" style={{ fontSize: "4rem" }}></i>
                        </div>

                        {/* Heading */}
                        <h2 className="fw-bold mb-3">Thank You!</h2>
                        <p className="text-white" style={{color:'white'}}>
                            Your order has been placed successfully. We’ve sent a confirmation
                            email with your order details.
                        </p>

                        {/* Order Summary Card */}
                        {/* <div className="card my-4 shadow-sm border-0">
                            <div className="card-body">
                                <h5 className="mb-3">Order Summary</h5>
                                <ul className="list-group list-group-flush text-start">
                                    <li className="list-group-item d-flex justify-content-between">
                                        <span>Order Number</span>
                                        <strong>#123456</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between">
                                        <span>Estimated Delivery</span>
                                        <strong>Sep 25, 2025</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between">
                                        <span>Payment Method</span>
                                        <strong>Credit Card</strong>
                                    </li>
                                </ul>
                            </div>
                        </div> */}

                        {/* CTA Buttons */}
                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <Link to="/" className="btn btn_black">
                                <i className="fa fa-home me-2"></i> Back To Home
                            </Link>
                         
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Thankyou